import React from 'react';
import { Box, Skeleton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import Panel from '../components/common/Panel';

// Loading placeholder for the Products overview table.
//
// 🔴 5 x 9, nicht 8 x 13 (W-39). Vorher standen hier 8 Zeilen x 13 Spalten =
// 104 Skelette fuer eine Tabelle, deren echte Zeile 52 px hoch ist und deren
// Desktop-Spaltenzahl auf 8 gefallen ist. Gemessen auf der Seite: **124**
// `.MuiSkeleton-root` allein aus dieser Datei. Ein Skelett ist ein Platzhalter,
// kein Versprechen ueber die Zeilenzahl — 5 Zeilen fuellen den sichtbaren
// Viewport, mehr braucht es nicht. Die Spaltenzahl folgt der echten Tabelle
// (Product, Category, On hand, Stock-out, List, Margin, 30d Sales, Price reco).
//
// Die zwei Zeilen des Werkzeugkastens werden mitgezeichnet, weil sie darueber
// liegen: Row 1 = Suche + Filter + Refresh, Row 2 = FilterPillRow.
const COLS = 8;
const ROWS = 5;

export default function ProductsTableSkeleton() {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Panel pad="card">
        {/* Row 1 — search + filter selects + refresh */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
          <Skeleton variant="rounded" height={36} sx={{ flex: 1, minWidth: 160 }} />
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} variant="rounded" width={110} height={36} />
          ))}
          <Skeleton variant="rounded" width={90} height={36} />
        </Box>
        {/* Row 2 — FilterPillRow */}
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} variant="rounded" width={110} height={28} />
          ))}
        </Box>
        {/* table */}
        <Box sx={{ mt: 1 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                {[...Array(COLS)].map((_, i) => (
                  <TableCell key={i}>
                    <Skeleton variant="text" width="70%" />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(ROWS)].map((_, r) => (
                <TableRow key={r}>
                  {[...Array(COLS)].map((_, c) => (
                    <TableCell key={c}>
                      <Skeleton variant="text" width={c === 0 ? '85%' : '55%'} />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Panel>
    </Box>
  );
}
